import React from 'react'
import { TRACK_EVENT_NAMES } from '@mote/helpers/constants'
import { useTrackMutation } from './useTrackMutation'

export const useTrackPurchaseFlow = () => {
  const { mutate, ...rest } = useTrackMutation()

  function handleTrack({
    productEnum,
    step,
    stage,
    data = {},
    hasStart = false,
    hasCompleted = false,
    hasFailed = false
  }) {
    const modifiedData = {
      ...data,
      productEnum,
      step,
      stage,
      purchaseFlowMode: true
    }

    if (hasStart) modifiedData.hasStart = hasStart
    else if (hasCompleted) modifiedData.hasCompleted = hasCompleted
    else if (hasFailed) modifiedData.hasFailed = hasFailed
    else modifiedData.isIntermediate = true

    return mutate({
      variables: {
        ...modifiedData,
        event: TRACK_EVENT_NAMES.commerce.purchaseFunnel
      }
    })
  }

  return { ...rest, mutate: handleTrack }
}
